<script>
export default {
  props: {
    soalStats: Object,
    listItem: Object,
    currentQuestion: Object,
    is_instruksi: Number,
    mengerjakan: Function,
    getQuestionNumber: Function,

    // Jawaban
    isBooleanQuestion: Boolean,
    // currentQuestion: Object,
    currentQuestionOptionList: Object,
    currentQuestionShuffleOptionList: Object,
    answers: Array,
    currentIndex: Number,
    hasImageOptions: Boolean,
    currentPage: Number,
    selectAnswer: Function,

    // navigasi
    // currentQuestion: Object,
    openProgressFinal: Function,
    nextQuestion: Function,
    // is_instruksi: Number,
    nextSoal: Function,
    last_page: Number,
    index_soal: Number,
    status_pengerjaan: Number,
    // mengerjakan: Function,
  },

  data() {
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
    };
  },
};
</script>

<template>
  <div v-if="currentQuestion" class="mym-question-body">
    <!-- NUMBER -->
    <div class="mym-card-case mb-3">
      <div class="mym-card-jumbotron-header">
        <div class="mym-card-jumbotron-icon text-light">
          <i class="fa fa-file-alt"></i>
        </div>

        <h3 class="mym-card-jumbotron-title">Studi Kasus</h3>
      </div>

      <div class="mym-card-jumbotron-content">
        {{ currentQuestion?.soal_text }}
      </div>
    </div>
    
    <div class="mym-question-navigation">
      <div class="mym-qn-header">
        <div class="mym-question-number">
          Soal
          <span class="mym-actived-number">{{ getQuestionNumber(index_soal) }}</span> /
          {{ soalStats.total }}
        </div>

      </div>

      <div class="mym-question-section">
        <div class="mb-3">
          <img
            v-if="currentQuestion?.soal_image"
            :src="BACKEND_URL + currentQuestion?.soal_image"
            class="mym-question-image"
          />
          <div class="mym-question-text">
            {{ currentQuestion?.pertanyaan }}
          </div>
        </div>
      </div>
    </div>

    <!-- ================= OPTIONS SECTION ================= -->
    <div class="mym-options-section">
      <div
        class="mym-options boolean-mode"
      >
        <div
          v-for="(jawaban, i) in currentQuestionOptionList"
          :key="i"
          class="mym-option-card boolean-card"
          :class="{ active: jawaban.selected }"
          @click="selectAnswer(currentQuestion, jawaban)"
        >
          <div class="boolean-content">
            <div class="boolean-icon">
              <span v-if="jawaban.selected" class="text-primary icon-i">
                <i class="fas fa-check-circle fa-fw"></i>
              </span>
              <span v-else>
                <i
                  v-if="jawaban.kode_jawaban == 'A'"
                  class="fa fa-check icon-i fa-fw"
                ></i>
                <i v-else class="fa fa-times icon-i fa-fw"></i>
              </span>
            </div>

            <div class="boolean-text">
              {{ jawaban.jawaban }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="mym-footer justify-content-end">
      <button
        v-if="last_page - 1 !== index_soal && status_pengerjaan === 0"
        class="mym-btn mym-bg-primary"
        type="button"
        @click="nextSoal(1)"
      >
        Selanjutnya
        <i class="fas fa-chevron-right ms-1"></i>
      </button>

      <button
        v-if="last_page - 1 === index_soal || status_pengerjaan === 1"
        class="mym-btn mym-bg-success"
        type="button"
        @click="$emit('modalProgressFinal')"
        style="width: 200px"
      >
        Selesai
        <i class="fas fa-check ms-1"></i>
      </button>
    </div>
  </div>
</template>